module.exports = __webpack_public_path__ + "img/70.9.TU.58ab48eb.png";